import { FINAL_OWNER_LABEL, FINAL_OWNER_ORDER, NO_TECH_OWNER, OPEN_STATUSES, SOURCE_LABEL, STAFF_SOURCES, STATUS_HINT, STATUS_LABEL, STATUS_ORDER, TYPE_LABEL, TYPE_ORDER } from "../../../src/shared/status";
import type { DueTone, RequestStatus, RequestType, SlaState } from "./types";

export { FINAL_OWNER_LABEL, FINAL_OWNER_ORDER, NO_TECH_OWNER, OPEN_STATUSES, SOURCE_LABEL, STAFF_SOURCES, STATUS_HINT, STATUS_ORDER, TYPE_LABEL, TYPE_ORDER };

/**
 * Display metadata for statuses and types — labels, dot colours, order.
 *
 * Apart from the fixtures on purpose: the customer portal renders statuses too,
 * and importing them from fixtures.ts would pull the staff sample data (account
 * briefs and all) into the customer bundle.
 */

/** Dot colour per status; labels and order come from the shared lifecycle module. */
const STATUS_DOT: Record<RequestStatus, string> = {
  new: "bg-gray-900",
  backlog: "bg-gray-400",
  decision: "bg-brand-500",
  triaged: "bg-grayblue-500",
  progress: "bg-turquoise-500",
  waiting: "bg-warning-400",
  validation: "bg-turquoise-700",
  done: "bg-success-500",
  supported: "bg-success-400",
  wontdo: "bg-gray-300",
  escalated: "bg-violet-500",
};

export const STATUS_META: Record<RequestStatus, { label: string; dot: string; order: number }> = Object.fromEntries(
  STATUS_ORDER.map((s, order) => [s, { label: STATUS_LABEL[s], dot: STATUS_DOT[s], order }]),
) as Record<RequestStatus, { label: string; dot: string; order: number }>;

/** TYPE_LABEL as select options, in the shared order. */
export const TYPE_OPTIONS: { value: RequestType; label: string }[] = TYPE_ORDER.map((value) => ({
  value,
  label: TYPE_LABEL[value],
}));

/** Text colour for a next-date tone: overdue reads in error colours, today in warning. */
export const NEXT_TONE_CLASS: Record<DueTone, string> = {
  overdue: "text-error-600",
  today: "text-warning-700",
  soon: "text-[var(--text-2)]",
  neutral: "text-[var(--text-2)]",
};

/** Label and colour for a request's SLA state. */
export const SLA_LABEL: Record<SlaState, string> = { ok: "On track", "at-risk": "At risk", breached: "Breached" };
export const SLA_CLASS: Record<SlaState, string> = { ok: "text-success-600", "at-risk": "text-warning-700", breached: "text-error-600" };
